import {useLocation} from 'react-router-dom'

import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'

const BaseLayout = ({children}) => {
  const location = useLocation()
  const splittedPath = location.pathname.split('/')
  const contentId = splittedPath[1]

  return (
    <>
      <Header />

      <div
        id={contentId ? `content-${contentId}` : 'content-home'}
        className="content"
      >
        {children}
      </div>

      <Footer />
    </>
  )
}

export default BaseLayout
